import { gql } from 'src/generated/gql';

export const SUBMIT_LAB_ORDER = gql(`
  mutation SubmitLabOrder($patientId: ID!) {
    staff_createLabOrder(patientId: $patientId)
  }
`);
